// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminUserForm-errorMessage-uW9sD {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.AdminUserForm-commonHeaderAdmin-XTFvG {
	position: fixed !important;
}
.AdminUserForm-adminLayout-bOyRB {
	padding-top: 64px !important;
}
.AdminUserForm-box-aUOmL h2 {
	font-size: 21px;
	font-weight: 600;
}
.AdminUserForm-exportLink-qxX1q {
	margin-bottom: -29px;
}
.AdminUserForm-blockCenter-XIU_L {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}
.AdminUserForm-panelHeader-_6x0l {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}
.AdminUserForm-currencyselect-DKQe7 {
	width: 100%;
	margin-right: 0px;
}
.AdminUserForm-panelHeader-_6x0l {
	overflow: hidden;
	position: relative;
}
.AdminUserForm-mar0-tizGj {
	margin-left: 0;
	margin-right: 0;
}
@media screen and (max-width: 767px) {
	.AdminUserForm-blockCenter-XIU_L {
		padding: 0px;
	}

	.AdminUserForm-panelHeader-_6x0l {
		padding: 24px 5px;
	}
}
/** Admin - Common - Start **/
.AdminUserForm-sideAdminPageWrapper-GGwz0 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}
.AdminUserForm-panelHeader-_6x0l {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}
.AdminUserForm-table-rSOUP {
	display: table;
}
.AdminUserForm-tableRow-XAU0D {
	display: table-row;
}
.AdminUserForm-tableCell-UhwUC {
	display: table-cell;
	float: none;
}
.AdminUserForm-formGroup-vIwWW {
	margin-bottom: 6px;
}
.AdminUserForm-select-IuNVV {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}
.AdminUserForm-noMargin-R5oet {
	margin: 0px;
}
a,
a:hover {
	cursor: pointer;
}
.AdminUserForm-exportLink-qxX1q {
	padding-top: 10px;
	padding-right: 10px;
}
.AdminUserForm-labelTextNew-ja3Om {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminUserForm-displayInline-iB7lF {
	display: inline-block;
}
/******************* Admin Modal ListSetting Start *******************/
.AdminUserForm-btnUPdate-WApV5 {
	display: inline-block;
}
.AdminUserForm-btnModalDelete-bNKqA {
	display: inline-block;
	margin-left: 15px;
}
.AdminUserForm-radioBtn-A6f7f {
	position: relative;
	top: 1px;
	vertical-align: middle;
}
.AdminUserForm-backgroundImg-U91pE {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}
@media screen and (max-width: 767px) {
	.AdminUserForm-btnUPdate-WApV5 {
		display: block;
		margin-bottom: 12px;
	}

	.AdminUserForm-btnModalDelete-bNKqA {
		display: block;
		margin-left: 0px;
	}

	.AdminUserForm-btnWidth-en9of {
		width: 100%;
	}
}
/******************* Admin Modal ListSetting Start *******************/
/******************* Admin Banner Image Section Start ****************/
.AdminUserForm-bannerImageBg-Huvf1 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}
.AdminUserForm-bannerDelete-cyzI0 {
	position: absolute;
	top: -12px;
	right: 4px;
}
/*******************Admin Modal Start **********************/
.AdminUserForm-modalRoot-YZcjV {
	padding: 32px;
}
.AdminUserForm-modalBorderBottom-jUZAq {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}
.AdminUserForm-logInModalBody-qmW9F {
	padding: 0px;
}
/*************** Admin TableNew Design Start**************************/
.AdminUserForm-exportSection-pCLiq {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}
.AdminUserForm-exportSectionGridSub-vvkU5 {
	grid-template-columns: 50% 49% !important;
}
.AdminUserForm-exportText-TZrXL {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}
.AdminUserForm-exportLinkImg-hiEoj {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}
.AdminUserForm-vtrMiddle-eQYWh {
	vertical-align: middle;
}
.AdminUserForm-exportImg-DQsgv {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}
.AdminUserForm-profileViewlabel-xL_On {
	display: inline-block;
	width: 38%
}
.AdminUserForm-profileViewMainContent-eaZJs {
	display: inline-block;
	width: 62%;
}
.AdminUserForm-profileViewMain-PR1wE {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.AdminUserForm-profileViewInner-jtnQv {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}
.AdminUserForm-profileImageSection-clnDA {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}
.AdminUserForm-lastviewInner-BGEvw {
	padding: 10px;
}
.AdminUserForm-whyHostHoriLine-NvBQj {
	margin: 30px 0;
}
.AdminUserForm-tableGrid-K8aeY {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}
.AdminUserForm-headingContent-_863P {
	font-size: 18px;
	font-weight: 500;
}
.AdminUserForm-refundTextColor-yXcYQ {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}
.AdminUserForm-dividerLine-inRfn {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}
.AdminUserForm-smallContent-e3Y7r {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}
@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminUserForm-sideAdminPageWrapper-GGwz0 {
		height: 100%;
		overflow: auto;
	}
}
@media (max-width:1199px) {
	.AdminUserForm-sideAdminPageWrapper-GGwz0 {
		margin-left: 0;
	}
}
@media screen and (max-width: 991px) {
	.AdminUserForm-exportSection-pCLiq {
		grid-template-columns: 100%;
	}

	.AdminUserForm-exportSectionGridSub-vvkU5 {
		grid-template-columns: 100% !important;
	}

}
@media screen and (max-width: 767px) {
	.AdminUserForm-profileViewlabel-xL_On {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminUserForm-profileViewMainContent-eaZJs {
		width: 100%;
		text-align: center;
	}
}
/*************** Admin TableNew Design End**************************/
.AdminUserForm-ChangeToUpperCase-Wr8rB {
	text-transform: uppercase
}
.AdminUserForm-noBorder-CZLPE {
	border: 0px !important;
}
/** Admin - Common - End **/
/* site Admin utility Start */
.AdminUserForm-siteAdminHeading-pe3up {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminUserForm-siteAdminSubHeading-bBAkq {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminUserForm-adminFormDivider-InHzg {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}
.AdminUserForm-space1-aDYEx {
	margin-bottom: 6px !important;
}
.AdminUserForm-space2-Szrbc {
	margin-bottom: 12px !important;
}
.AdminUserForm-space3-ixfH_ {
	margin-bottom: 18px !important;
}
.AdminUserForm-space4-p8W1k {
	margin-bottom: 24px !important;
}
.AdminUserForm-space5-ONITQ {
	margin-bottom: 30px !important;
}
.AdminUserForm-space6-aWlny {
	margin-bottom: 36px !important;
}
.AdminUserForm-space7-w_0UG {
	margin-bottom: 42px !important;
}
.AdminUserForm-spaceTop8-A9elC {
	margin-bottom: 48px !important;
}
.AdminUserForm-spaceTop1-Lzd00 {
	margin-top: 6px !important;
}
.AdminUserForm-spaceTop2-gJTOU {
	margin-top: 12px !important;
}
.AdminUserForm-spaceTop3-ij7ZB {
	margin-top: 18px !important;
}
.AdminUserForm-spaceTop4-Ihd45 {
	margin-top: 24px !important;
}
.AdminUserForm-spaceTop5-TxSis {
	margin-top: 30px !important;
}
.AdminUserForm-spaceTop6-EZUXv {
	margin-top: 36px !important;
}
.AdminUserForm-spaceTop7-tGmew {
	margin-top: 42px !important;
}
.AdminUserForm-spaceTop8-A9elC {
	margin-top: 48px !important;
}
.AdminUserForm-noMargin-R5oet {
	margin: 0px !important;
}
.AdminUserForm-padding1-FGElr {
	padding-bottom: 6px !important;
}
.AdminUserForm-padding2-dLEf_ {
	padding-bottom: 12px !important;
}
.AdminUserForm-padding3-lSb_G {
	padding-bottom: 18px !important;
}
.AdminUserForm-padding4-fUarO {
	padding-bottom: 24px !important;
}
.AdminUserForm-padding5-owq0I {
	padding-bottom: 30px !important;
}
.AdminUserForm-padding6-K_9X2 {
	padding-bottom: 36px !important;
}
.AdminUserForm-padding7-JGehB {
	padding-bottom: 42px !important;
}
.AdminUserForm-paddingTop1-y43bG {
	padding-top: 6px !important;
}
.AdminUserForm-paddingTop2-xW39Q {
	padding-top: 12px !important;
}
.AdminUserForm-paddingTop3-PGtp5 {
	padding-top: 18px !important;
}
.AdminUserForm-paddingTop4-J0UW1 {
	padding-top: 24px !important;
}
.AdminUserForm-paddingTop5-wQUxr {
	padding-top: 30px !important;
}
.AdminUserForm-paddingTop6-kUVnq {
	padding-top: 36px !important;
}
.AdminUserForm-paddingTop7-Q0XAs {
	padding-top: 42px !important;
}
.AdminUserForm-noPadding-Zp7DW {
	padding: 0px !important;
}
.AdminUserForm-textBold-XY23M {
	font-weight: 500 !important;
}
.AdminUserForm-textBolder-vfJbm {
	font-weight: 700 !important;
}
.AdminUserForm-textNormal-Q1uxn {
	font-weight: normal !important;
}
.AdminUserForm-spaceBottom20-ES6ii {
	margin-bottom: 20px;
}
.AdminUserForm-spaceBottom10-WSpSt {
	margin-bottom: 10px;
}
.AdminUserForm-marginNone-a1yWr {
	margin: 0;
}
.AdminUserForm-spaceBottom15-_nMQz {
	margin-bottom: 15px;
}
.AdminUserForm-marginTopNone-KYt6W {
	margin-top: 0;
}
.AdminUserForm-spaceTop11-b8zEv {
	margin-top: 11px;
}
.AdminUserForm-spaceTop21-Ygw7I {
	margin-top: 21px;
}
.AdminUserForm-spaceTop20-P5eQv {
	margin-top: 20px;
}
.AdminUserForm-spaceTop10-WDHwF {
	margin-top: 10px;
}
/*New Design Text Colors */
.AdminUserForm-textDarkBlue-qhPNm {
	color: rgb(20, 39, 94) !important;
}
.AdminUserForm-textLightBlue-EOh2V {
	color: rgb(57, 87, 106) !important;
}
.AdminUserForm-textLightSandleGreen-CjHtI {
	color: rgb(76, 86, 41) !important;
}
.AdminUserForm-textLightBrown-NKlNF {
	color: rgb(115, 79, 33) !important;
}
.AdminUserForm-textMediumMaroon-VTTKU {
	color: rgb(87, 37, 51) !important;
}
.AdminUserForm-textBrown-FkOvK {
	color: rgb(160, 47, 24) !important;
}
.AdminUserForm-textMaroon-m3Tt5 {
	color: rgb(155, 49, 67) !important;
}
.AdminUserForm-textDarkBrown-LsdMe {
	color: rgb(83, 18, 16) !important;
}
.AdminUserForm-textMediumBrown-_fSOu {
	color: rgb(142, 28, 10) !important;
}
.AdminUserForm-textSkyBlue-YIiCc {
	color: rgb(37, 117, 141) !important;
}
.AdminUserForm-textGray-dWrAS {
	color: rgb(77, 65, 51) !important;
}
.AdminUserForm-userText-Q022K {
    color: var(--secondary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/AdminUserForm/AdminUserForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,0BAA0B;AAC3B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,eAAe;AAChB;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;ACpDA,6BAA6B;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;;CAEC,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,qBAAqB;AACtB;AAEA,sEAAsE;AAEtE;CACC,qBAAqB;AACtB;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;AAEA,sEAAsE;AAEtE,sEAAsE;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;AAEA,4DAA4D;AAE5D;CACC,aAAa;AACd;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;AAEA;CACC,YAAY;AACb;AAEA,sEAAsE;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB;AACD;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,aAAa;AACd;AAEA;CACC,cAAc;AACf;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;AAEA;CACC;EACC,cAAc;CACf;AACD;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;AAEA,oEAAoE;AAEpE;CACC;AACD;AAEA;CACC,sBAAsB;AACvB;AAEA,2BAA2B;AAE3B,6BAA6B;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;ACvUA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACxNA;IACI,kCAAkC;AACtC","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../admin-common.css';\n@import '../../helpers.css';\n\n.userText {\n    color: var(--secondary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AdminUserForm-errorMessage-uW9sD`,
	"commonHeaderAdmin": `AdminUserForm-commonHeaderAdmin-XTFvG`,
	"adminLayout": `AdminUserForm-adminLayout-bOyRB`,
	"box": `AdminUserForm-box-aUOmL`,
	"exportLink": `AdminUserForm-exportLink-qxX1q`,
	"blockCenter": `AdminUserForm-blockCenter-XIU_L`,
	"panelHeader": `AdminUserForm-panelHeader-_6x0l`,
	"currencyselect": `AdminUserForm-currencyselect-DKQe7`,
	"mar0": `AdminUserForm-mar0-tizGj`,
	"sideAdminPageWrapper": `AdminUserForm-sideAdminPageWrapper-GGwz0`,
	"table": `AdminUserForm-table-rSOUP`,
	"tableRow": `AdminUserForm-tableRow-XAU0D`,
	"tableCell": `AdminUserForm-tableCell-UhwUC`,
	"formGroup": `AdminUserForm-formGroup-vIwWW`,
	"select": `AdminUserForm-select-IuNVV`,
	"noMargin": `AdminUserForm-noMargin-R5oet`,
	"labelTextNew": `AdminUserForm-labelTextNew-ja3Om`,
	"displayInline": `AdminUserForm-displayInline-iB7lF`,
	"btnUPdate": `AdminUserForm-btnUPdate-WApV5`,
	"btnModalDelete": `AdminUserForm-btnModalDelete-bNKqA`,
	"radioBtn": `AdminUserForm-radioBtn-A6f7f`,
	"backgroundImg": `AdminUserForm-backgroundImg-U91pE`,
	"btnWidth": `AdminUserForm-btnWidth-en9of`,
	"bannerImageBg": `AdminUserForm-bannerImageBg-Huvf1`,
	"bannerDelete": `AdminUserForm-bannerDelete-cyzI0`,
	"modalRoot": `AdminUserForm-modalRoot-YZcjV`,
	"modalBorderBottom": `AdminUserForm-modalBorderBottom-jUZAq`,
	"logInModalBody": `AdminUserForm-logInModalBody-qmW9F`,
	"exportSection": `AdminUserForm-exportSection-pCLiq`,
	"exportSectionGridSub": `AdminUserForm-exportSectionGridSub-vvkU5`,
	"exportText": `AdminUserForm-exportText-TZrXL`,
	"exportLinkImg": `AdminUserForm-exportLinkImg-hiEoj`,
	"vtrMiddle": `AdminUserForm-vtrMiddle-eQYWh`,
	"exportImg": `AdminUserForm-exportImg-DQsgv`,
	"profileViewlabel": `AdminUserForm-profileViewlabel-xL_On`,
	"profileViewMainContent": `AdminUserForm-profileViewMainContent-eaZJs`,
	"profileViewMain": `AdminUserForm-profileViewMain-PR1wE`,
	"profileViewInner": `AdminUserForm-profileViewInner-jtnQv`,
	"profileImageSection": `AdminUserForm-profileImageSection-clnDA`,
	"lastviewInner": `AdminUserForm-lastviewInner-BGEvw`,
	"whyHostHoriLine": `AdminUserForm-whyHostHoriLine-NvBQj`,
	"tableGrid": `AdminUserForm-tableGrid-K8aeY`,
	"headingContent": `AdminUserForm-headingContent-_863P`,
	"refundTextColor": `AdminUserForm-refundTextColor-yXcYQ`,
	"dividerLine": `AdminUserForm-dividerLine-inRfn`,
	"smallContent": `AdminUserForm-smallContent-e3Y7r`,
	"ChangeToUpperCase": `AdminUserForm-ChangeToUpperCase-Wr8rB`,
	"noBorder": `AdminUserForm-noBorder-CZLPE`,
	"siteAdminHeading": `AdminUserForm-siteAdminHeading-pe3up`,
	"siteAdminSubHeading": `AdminUserForm-siteAdminSubHeading-bBAkq`,
	"adminFormDivider": `AdminUserForm-adminFormDivider-InHzg`,
	"space1": `AdminUserForm-space1-aDYEx`,
	"space2": `AdminUserForm-space2-Szrbc`,
	"space3": `AdminUserForm-space3-ixfH_`,
	"space4": `AdminUserForm-space4-p8W1k`,
	"space5": `AdminUserForm-space5-ONITQ`,
	"space6": `AdminUserForm-space6-aWlny`,
	"space7": `AdminUserForm-space7-w_0UG`,
	"spaceTop8": `AdminUserForm-spaceTop8-A9elC`,
	"spaceTop1": `AdminUserForm-spaceTop1-Lzd00`,
	"spaceTop2": `AdminUserForm-spaceTop2-gJTOU`,
	"spaceTop3": `AdminUserForm-spaceTop3-ij7ZB`,
	"spaceTop4": `AdminUserForm-spaceTop4-Ihd45`,
	"spaceTop5": `AdminUserForm-spaceTop5-TxSis`,
	"spaceTop6": `AdminUserForm-spaceTop6-EZUXv`,
	"spaceTop7": `AdminUserForm-spaceTop7-tGmew`,
	"padding1": `AdminUserForm-padding1-FGElr`,
	"padding2": `AdminUserForm-padding2-dLEf_`,
	"padding3": `AdminUserForm-padding3-lSb_G`,
	"padding4": `AdminUserForm-padding4-fUarO`,
	"padding5": `AdminUserForm-padding5-owq0I`,
	"padding6": `AdminUserForm-padding6-K_9X2`,
	"padding7": `AdminUserForm-padding7-JGehB`,
	"paddingTop1": `AdminUserForm-paddingTop1-y43bG`,
	"paddingTop2": `AdminUserForm-paddingTop2-xW39Q`,
	"paddingTop3": `AdminUserForm-paddingTop3-PGtp5`,
	"paddingTop4": `AdminUserForm-paddingTop4-J0UW1`,
	"paddingTop5": `AdminUserForm-paddingTop5-wQUxr`,
	"paddingTop6": `AdminUserForm-paddingTop6-kUVnq`,
	"paddingTop7": `AdminUserForm-paddingTop7-Q0XAs`,
	"noPadding": `AdminUserForm-noPadding-Zp7DW`,
	"textBold": `AdminUserForm-textBold-XY23M`,
	"textBolder": `AdminUserForm-textBolder-vfJbm`,
	"textNormal": `AdminUserForm-textNormal-Q1uxn`,
	"spaceBottom20": `AdminUserForm-spaceBottom20-ES6ii`,
	"spaceBottom10": `AdminUserForm-spaceBottom10-WSpSt`,
	"marginNone": `AdminUserForm-marginNone-a1yWr`,
	"spaceBottom15": `AdminUserForm-spaceBottom15-_nMQz`,
	"marginTopNone": `AdminUserForm-marginTopNone-KYt6W`,
	"spaceTop11": `AdminUserForm-spaceTop11-b8zEv`,
	"spaceTop21": `AdminUserForm-spaceTop21-Ygw7I`,
	"spaceTop20": `AdminUserForm-spaceTop20-P5eQv`,
	"spaceTop10": `AdminUserForm-spaceTop10-WDHwF`,
	"textDarkBlue": `AdminUserForm-textDarkBlue-qhPNm`,
	"textLightBlue": `AdminUserForm-textLightBlue-EOh2V`,
	"textLightSandleGreen": `AdminUserForm-textLightSandleGreen-CjHtI`,
	"textLightBrown": `AdminUserForm-textLightBrown-NKlNF`,
	"textMediumMaroon": `AdminUserForm-textMediumMaroon-VTTKU`,
	"textBrown": `AdminUserForm-textBrown-FkOvK`,
	"textMaroon": `AdminUserForm-textMaroon-m3Tt5`,
	"textDarkBrown": `AdminUserForm-textDarkBrown-LsdMe`,
	"textMediumBrown": `AdminUserForm-textMediumBrown-_fSOu`,
	"textSkyBlue": `AdminUserForm-textSkyBlue-YIiCc`,
	"textGray": `AdminUserForm-textGray-dWrAS`,
	"userText": `AdminUserForm-userText-Q022K`
};
module.exports = ___CSS_LOADER_EXPORT___;
